var _rect, _path, _path2, _circle, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4.7499,
    y: 8.61953,
    width: 16.9777,
    height: 9.20318,
    rx: 0.65,
    fill: "white",
    stroke: "#363A45",
    strokeWidth: 0.7
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.37012 13.9941H19.1069V21.4039C19.1069 21.9562 18.6591 22.4039 18.1069 22.4039H8.37012C7.81783 22.4039 7.37012 21.9562 7.37012 21.4039V13.9941Z",
    fill: "#00C65E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.72012 6.01758C7.72012 5.65859 8.01113 5.36758 8.37012 5.36758H18.1069C18.4658 5.36758 18.7569 5.65859 18.7569 6.01758V8.58659H7.72012V6.01758Z",
    fill: "white",
    stroke: "#363A45",
    strokeWidth: 0.7
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.3112,
    cy: 11.0481,
    r: 0.835166,
    fill: "#00C65E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.99365 13.8633H19.4831",
    stroke: "#363A45",
    strokeWidth: 0.7,
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon5);
export default __webpack_public_path__ + "static/media/icon5.b496997307fc2f8f1c3bbef24edaa951.svg";
export { ForwardRef as ReactComponent };